module.exports = __webpack_public_path__ + "img/asset_SOL-USDT.0e868ccd.png";